export default {
  'userandlogin.login.userName': 'userName',
  'userandlogin.login.password': 'password',
  'userandlogin.login.message-invalid-credentials':
    'Invalid username or password（admin/ant.design）',
  'userandlogin.login.message-invalid-verification-code': 'Invalid verification code',
  'userandlogin.login.tab-login-credentials': 'Credentials',
  'userandlogin.login.tab-login-mobile': 'Mobile number',
  'userandlogin.login.remember-me': 'Remember me',
  'userandlogin.login.forgot-password': 'Forgot your password?',
  'userandlogin.login.sign-in-with': 'Sign in with',
  'userandlogin.login.signup': 'Sign up',
  'userandlogin.login.login': 'Login',
  'userandlogin.register.register': 'Register',
  'userandlogin.register.get-verification-code': 'Get code',
  'userandlogin.register.sign-in': 'Already have an account?',
  'userandlogin.register-result.msg': 'Account：registered at {email}',
  'userandlogin.register-result.activation-email':
    'The activation email has been sent to your email address and is valid for 24 hours. Please log in to the email in time and click on the link in the email to activate the account.',
  'userandlogin.register-result.back-home': 'Back to home',
  'userandlogin.register-result.view-mailbox': 'View mailbox',
  'userandlogin.email.required': 'Please enter your email!',
  'userandlogin.email.wrong-format': 'The email address is in the wrong format!',
  'userandlogin.userName.required': 'Please enter your userName!',
  'userandlogin.password.required': 'Please enter your password!',
  'userandlogin.password.twice': 'The passwords entered twice do not match!',
  'userandlogin.strength.msg':
    "Please enter at least 6 characters and don't use passwords that are easy to guess.",
  'userandlogin.strength.strong': 'Strength: strong',
  'userandlogin.strength.medium': 'Strength: medium',
  'userandlogin.strength.short': 'Strength: too short',
  'userandlogin.confirm-password.required': 'Please confirm your password!',
  'userandlogin.phone-number.required': 'Please enter your phone number!',
  'userandlogin.phone-number.wrong-format': 'Malformed phone number!',
  'userandlogin.verification-code.required': 'Please enter the verification code!',
  'userandlogin.title.required': 'Please enter a title',
  'userandlogin.date.required': 'Please select the start and end date',
  'userandlogin.goal.required': 'Please enter a description of the goal',
  'userandlogin.standard.required': 'Please enter a metric',
  'userandlogin.form.get-captcha': 'Get Captcha',
  'userandlogin.captcha.second': 'sec',
  'userandlogin.form.optional': ' (optional) ',
  'userandlogin.form.submit': 'Submit',
  'userandlogin.form.save': 'Save',
  'userandlogin.email.placeholder': 'Email',
  'userandlogin.password.placeholder': 'Password',
  'userandlogin.confirm-password.placeholder': 'Confirm password',
  'userandlogin.phone-number.placeholder': 'Phone number',
  'userandlogin.verification-code.placeholder': 'Verification code',
  'userandlogin.title.label': 'Title',
  'userandlogin.title.placeholder': 'Give the target a name',
  'userandlogin.date.label': 'Start and end date',
  'userandlogin.placeholder.start': 'Start date',
  'userandlogin.placeholder.end': 'End date',
  'userandlogin.goal.label': 'Goal description',
  'userandlogin.goal.placeholder': 'Please enter your work goals',
  'userandlogin.standard.label': 'Metrics',
  'userandlogin.standard.placeholder': 'Please enter a metric',
  'userandlogin.client.label': 'Client',
  'userandlogin.label.tooltip': 'Target service object',
  'userandlogin.client.placeholder':
    'Please describe your customer service, internal customers directly @ Name / job number',
  'userandlogin.invites.label': 'Inviting critics',
  'userandlogin.invites.placeholder':
    'Please direct @ Name / job number, you can invite up to 5 people',
  'userandlogin.weight.label': 'Weight',
  'userandlogin.weight.placeholder': 'Please enter weight',
  'userandlogin.public.label': 'Target disclosure',
  'userandlogin.label.help': 'Customers and invitees are shared by default',
  'userandlogin.radio.public': 'Public',
  'userandlogin.radio.partially-public': 'Partially public',
  'userandlogin.radio.private': 'Private',
  'userandlogin.publicUsers.placeholder': 'Open to',
  'userandlogin.option.A': 'Colleague A',
  'userandlogin.option.B': 'Colleague B',
  'userandlogin.option.C': 'Colleague C',
  'userandlogin.navBar.lang': 'Languages',
};
